const messages = {
  iva: '*El costo incluye IVA',
  igv: '*El costo incluye IGV',
  total: 'Total:',
}

export default messages
